module.exports = {"start_point":{"x":3,"y":4},"enemy_spawn":[{"x":9,"y":7},{"x":13,"y":7},{"x":22,"y":12}],"spawn_counter":2,"enemy_counter":5,"eagle":{"x":12,"y":10},"walls":[{"x":8,"y":6},{"x":8,"y":8},{"x":10,"y":11},{"x":13,"y":4},{"x":15,"y":14},{"x":16,"y":9},{"x":18,"y":5},{"x":19,"y":6},{"x":19,"y":11}],"water":[{"x":13,"y":9},{"x":19,"y":8}],"leaves":[{"x":7,"y":11},{"x":8,"y":3},{"x":9,"y":3},{"x":14,"y":5},{"x":16,"y":14}]}


//////////////////
// WEBPACK FOOTER
// ./src/game/maps/eftgt.json
// module id = 14
// module chunks = 0